/**
 * DraftUnitsGate — resolves whether a draft offer has any nośniki, using the
 * same cheap `pageSize: 1` grand-total fetch the units tab's own footer
 * already uses to read the offer's true unit count (offerUnitQueries.grandTotal),
 * rather than a bespoke draft-only endpoint or the paginated `useOfferUnits`
 * list.
 *
 * Extracted into its own component and mounted only for a showable `DRAFT`
 * offer — never called unconditionally in `OfferFinalizationSection` — so no
 * other status adds this request on every workspace load (offer-approval /
 * "Finalization path in the offer workspace").
 */
import type { ReactNode } from 'react';
import { useOfferUnitsGrandTotal } from '../units-tab/api/queries';

export function DraftUnitsGate({
  offerId,
  children,
}: {
  offerId: number;
  children: (hasUnits: boolean) => ReactNode;
}) {
  const { totalCount, isLoading } = useOfferUnitsGrandTotal(offerId, { enabled: true });
  // Default to "has units" while loading rather than flashing the
  // needs-nośniki line for an offer that turns out not to be empty.
  const hasUnits = isLoading || (totalCount ?? 0) > 0;
  return <>{children(hasUnits)}</>;
}
